<template>
	<dashboard-dropdown-section
		title="Unavailabilities Set"
		type="locum-unavailabilities-set"
		:items-shown="5"
		:items="unavailabilities"
		event-name="load-locum-unavailabilities-set"
		@load-locum-unavailabilities-set="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumAvailabilities',

	components: { DashboardDropdownSection },

	data: () => ({
		unavailabilities: [],
	}),

	methods: {
		...mapActions('availability', ['FetchProfessionalAvailability']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const unavailabilityResults = await this.FetchProfessionalAvailability({ startDate, endDate, availabilityType: 'unavailabilities' });
			this.unavailabilities = unavailabilityResults.map(unavailability => ({ ...unavailability, event_start_date: unavailability.date }));
		},
	},
};
</script>
